module.exports = __webpack_public_path__ + "img/4.61c0b35f.png";